import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  IUserAccess,
  IUserTenantProfile,
} from 'src/app/shared/user-view/models/tenant-user-access.model';
import { IUserOptions } from 'src/app/shared/user-view/models/user-options.model';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UserOptionsApiService {
  private readonly url = `${environment.apiUrl}/api/Options`;
  private readonly accessUrl = `${environment.apiUrl}/api/UserAccess/Me/v2`;
  private readonly tenantProfileUrl = `${environment.apiUrl}/api/UserAccess/Me`;

  constructor(private http: HttpClient) {}

  getOptions(): Observable<IUserOptions> {
    return this.http.get<IUserOptions>(this.url);
  }

  getUserAccess(tenantId: string): Observable<IUserAccess> {
    let queryParams = new HttpParams();
    queryParams = queryParams.append('ExcludeArchived', 'true');

    if (tenantId === '') {
      // initially we send request without specyfying tenantId
      // so API will return first tenantId
      // for people with only one tenantId it will be their default
      return this.http.get<IUserAccess>(this.accessUrl, { params: queryParams });
    }
    // if a user is requesting a specific tenantId
    // then we pass it inside queryParams
    queryParams = queryParams.append('tenantId', tenantId);
    return this.http.get<IUserAccess>(this.accessUrl, { params: queryParams });
  }

  getTenantUserProfile(tenantId: string): Observable<IUserTenantProfile> {
    return this.http.get<IUserTenantProfile>(`${this.tenantProfileUrl}/${tenantId}`);
  }
}
